import Cookies from 'universal-cookie'
// import { AppDispatch } from '../redux/store'
// import * as userDucks from '../redux/ducks/userDucks'

const cookies = new Cookies()

function parseCookieJson<T = Record<string, unknown>>(raw: unknown): T | null {
  if (raw === null || raw === undefined || raw === '') return null
  if (typeof raw === 'object') return raw as T
  if (typeof raw === 'string') {
    try {
      return JSON.parse(raw) as T
    } catch {
      return null
    }
  }
  return null
}

function readJwtPayload(): Record<string, unknown> | null {
  try {
    const token = cookies.get('access_token')
    if (!token) return null
    return JSON.parse(atob(token.split('.')[1]))
  } catch {
    return null
  }
}

export function logOut() {
  cookies.remove('access_token', { path: '/' })
  cookies.remove('user_info', { path: '/' })
  window.location.href = '/login'
  window.location.reload()
}

export function logOutAll() {
  cookies.remove('access_all_token', { path: '/' })
  // Không reload — LoginAll giữ form đăng nhập SSO (tránh màn trắng / vòng redirect).
}

// Get
export function getAccessAllToken() {
  return cookies.get('access_all_token')
}

export function getAccessToken() {
  return cookies.get('access_token')
}

export function getUserRole() {
  return cookies.get('user_role')
}

export function getSystemInfo() {
  return parseCookieJson<{ id?: number; ma?: string; ten?: string }>(cookies.get('system_info')) ?? {}
}

export function getUserInfo() {
  return parseCookieJson<{ id?: number; username?: string }>(cookies.get('user_info')) ?? {}
}

export function getDisplayUsername(): string {
  const info = getUserInfo()
  if (info?.username) return String(info.username)
  const payload = readJwtPayload()
  if (payload?.username) return String(payload.username)
  return ''
}

export function getManagedHeThongIds(): number[] {
  try {
    const raw = cookies.get('managed_hethong_ids')
    if (Array.isArray(raw)) return raw.map(Number).filter((n) => Number.isFinite(n))
    const fromJwt = readJwtPayload()?.managedHeThongIds
    return Array.isArray(fromJwt) ? fromJwt.map(Number).filter((n) => Number.isFinite(n)) : []
  } catch {
    return []
  }
}

export function saveManagedHeThongIds(ids: number[]) {
  return cookies.set('managed_hethong_ids', JSON.stringify(ids), { path: '/' })
}

export function getManagedDuAnIds(): number[] {
  try {
    const raw = cookies.get('managed_duan_ids')
    if (Array.isArray(raw)) return raw.map(Number).filter((n) => Number.isFinite(n))
    // Fallback JWT nếu cookie chưa có (session cũ / đổi HT)
    const fromJwt = readJwtPayload()?.managedDuAnIds
    return Array.isArray(fromJwt) ? fromJwt.map(Number).filter((n) => Number.isFinite(n)) : []
  } catch {
    return []
  }
}

export function saveManagedDuAnIds(ids: number[]) {
  return cookies.set('managed_duan_ids', JSON.stringify(ids), { path: '/' })
}

/** Sub-admin = có danh sách hệ thống/mảng được giao (không phải super_admin thuần). */
export function isSubAdminUser(): boolean {
  return getManagedHeThongIds().length > 0 || getManagedDuAnIds().length > 0
}

export function canManageCurrentHeThong(): boolean {
  const sys = getSystemInfo()
  const managed = getManagedHeThongIds()
  if (!managed.length) return false
  if (!sys?.id) return false
  return managed.includes(Number(sys.id))
}

export function canManageDuAn(duAnId: number | string | null | undefined): boolean {
  if (duAnId == null || duAnId === '') return false
  // Super admin (không bị giới hạn managed*): full access
  if (!isSubAdminUser()) return true
  const managed = getManagedDuAnIds()
  // Sub-admin nhưng chưa có managedDuAnIds → không cho (bắt login lại / gán lại)
  if (!managed.length) return false
  return managed.includes(Number(duAnId))
}




// Set
export function saveAccessAllToken(value: string) {
  return cookies.set('access_all_token', value, {
    path: '/',
  })
}

export function saveAccessToken(value: string) {
  return cookies.set('access_token', value, {
    path: '/',
  })
}

export function saveUserRole(value: string) {
  return cookies.set('user_role', value, {
    path: '/',
  })
}

export function saveSystemInfo(value: string) {
  return cookies.set('system_info', value, {
    path: '/',
  })
}

export function saveUserInfo(value: string | Record<string, unknown>) {
  const stored = typeof value === 'string' ? value : JSON.stringify(value)
  return cookies.set('user_info', stored, {
    path: '/',
  })
}

// Decode JWT token và check expiration
function isTokenValid(token: string | undefined): boolean {
  if (!token) return false
  
  try {
    // JWT format: header.payload.signature
    const parts = token.split('.')
    if (parts.length !== 3) return false
    
    // Decode payload (base64)
    const payload = JSON.parse(atob(parts[1]))
    
    // Check expiration (exp is in seconds, Date.now() is in milliseconds)
    if (payload.exp) {
      const expirationTime = payload.exp * 1000 // Convert to milliseconds
      const currentTime = Date.now()
      return currentTime < expirationTime
    }
    
    // If no exp field, consider token as valid (but expired tokens should have exp)
    return true
  } catch (error) {
    console.error('Error decoding token:', error)
    return false
  }
}

export function isLoggedIn() {
  const token = getAccessToken()
  return !!token && isTokenValid(token)
}

export function isLoggedInAll() {
  const token = getAccessAllToken()
  return !!token && isTokenValid(token)
}

export const getProjectInfo = (userDuAns: any[] = []) => {
  return userDuAns.map(item => ({
    duAnId: item.duAnId,
    duAn: item.duAn,
    role: item.role
  }))
}
